export default __webpack_public_path__ + "static/media/ico-mobile-hamburger-close.f88be9c9.svg";